import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainSection() {
  const pains = ['Llegás a mitad de mes y ya no sabés a dónde fue la mitad del sueldo', 'Tenés pesos parados en una caja de ahorro que la inflación come cada día', 'Las deudas de tarjeta crecen aunque pagás la cuota religiosamente', 'Comprás en el súper sin lista y sin estrategia, y el ticket siempre es más de lo que esperabas', 'No tenés ni un dólar ahorrado porque "con lo que gano no alcanza para eso"', 'Cada devaluación te golpea igual que la anterior porque nunca lograste protegerte', 'Tenés ingresos solo de una fuente y si esa fuente falla, no hay plan B', 'Sabés que deberías organizarte pero nunca encontraste un sistema que funcione para la Argentina real'];
  return <section className="py-8 md:py-16 px-4 max-w-4xl mx-auto" data-id="element-266">
      <FadeIn data-id="element-267">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-3 md:mb-6 px-2 text-[#0f172a]" data-id="element-268">
          ¿Hasta cuándo vas a trabajar para la inflación?
        </h2>

        <div className="text-sm md:text-xl text-[#475569] text-center mb-5 md:mb-12 space-y-2.5 md:space-y-4 max-w-3xl mx-auto font-medium" data-id="element-269">
          <p data-id="element-270">
            Cada mes que pasa sin sistema es un mes que el dinero hace lo que
            quiere con vos. No al revés.
          </p>
          <p className="font-bold text-[#0f172a] text-lg md:text-2xl mt-4 md:mt-8" data-id="element-271">
            No es falta de plata.{' '}
            <span className="text-[#ef4444]" data-id="element-272">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-16" data-id="element-273">
        {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-274">
            <motion.div whileHover={{
          scale: 1.02,
          backgroundColor: '#f8fafc'
        }} className="bg-white border border-[#e2e8f0] rounded-2xl p-4 md:p-6 flex gap-3 md:gap-4 items-start h-full transition-colors shadow-sm" data-id="element-275">
              <XCircle className="text-[#ef4444] shrink-0 mt-0.5 w-5 h-5 md:w-6 md:h-6" data-id="element-276" />
              <span className="text-sm md:text-lg text-[#0f172a] leading-relaxed font-medium" data-id="element-277">
                {pain}
              </span>
            </motion.div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.6} data-id="element-278">
        <div className="text-center relative" data-id="element-279">
          <div className="absolute inset-0 bg-[#22c55e]/10 blur-3xl rounded-full" data-id="element-280"></div>
          <motion.div animate={{
          y: [0, -5, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="relative z-10 inline-flex flex-col items-center" data-id="element-281">
            <Sparkles className="text-[#C9A84C] mb-2 md:mb-4 w-6 h-6 md:w-8 md:h-8" data-id="element-282" />
            <h3 className="text-2xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#16a34a] via-[#22c55e] to-[#4ade80] drop-shadow-sm px-2" data-id="element-283">
              ¿Y si este mes fuera el último que terminás así?
            </h3>
          </motion.div>
        </div>
      </FadeIn>
    </section>;
}